import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { BehaviorSubject, Observable } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { environment } from '../../../../environments/environment';
import { CommonService } from '../../../vass-core/services/common.service';
import { CommentModel } from '../../models/comment.model';
import { WallRequestModel } from '../../models/wall-request.model';

@Injectable()
export class WallService {
  // listComments: CommentModel[] = [];
  private unread: BehaviorSubject<number> = new BehaviorSubject(0);
  private listComments: BehaviorSubject<CommentModel[]> = new BehaviorSubject([]);
  private completeScroll: BehaviorSubject<boolean> = new BehaviorSubject(false);
  private errorGetCommnents: BehaviorSubject<Object> = new BehaviorSubject(undefined);
  private commentsInterval;
  public markAsRead: boolean = false;
  private numSubscriptions = 0;
  private timmerInterval = 60 * 1000;

  constructor(
    private commonService: CommonService,
    private http: HttpClient,
  ) {}

  private getComments(
    commentId?: string,
    size: number = 10,
    useLoader: boolean = false,
  ): Observable<WallRequestModel> {
    let params: HttpParams = new HttpParams();
    if (commentId) {
      params = params.append('commentId', commentId);
    }

    size = this.unread.getValue() > size ? this.unread.getValue() : size;
    if (size) {
      params = params.append('size', String(size));
    }

    const url = `${environment.apiBase}/mortgages-wall/${environment.api_version.wall}/comments`;
    // const url = `./assets/mocks/wall.mock.json`;

    return this.commonService.getVerb<WallRequestModel>(url, useLoader, params).pipe(
      map((resp: WallRequestModel) => {
        this.completeScroll.next(resp.comments.length < size);
        if (commentId) {
          resp.comments = this.returnNewComments(resp.comments);
        } else {
          resp.comments = [
            ...this.returnNewComments(resp.comments),
            ...this.listComments.getValue(),
          ];
        }
        return resp;
      }),
    );
  }

  private returnNewComments(listServer: CommentModel[]) {
    const listNewComments: CommentModel[] = [];

    listServer.forEach((element) => {
      const newComent = this.listComments
        .getValue()
        .find((e) => e.commentId === element.commentId);
      if (!newComent) {
        listNewComments.push(element);
      }
    });

    return listNewComments;
  }

  public setComment(body: { text: string; createdBy: string }) {
    const url = `${environment.apiBase}/mortgages-wall/${environment.api_version.wall}/comments`;
    return this.commonService.postVerb(url, body);
  }

  public getMoreComments(size: number = 11) {
    const commentId = this.listComments.getValue()[0]
      ? this.listComments.getValue()[this.listComments.getValue().length - 1].commentId
      : undefined;
    this.getComments(commentId, size, true).subscribe(
      (resp) => {
        if (resp) {
          resp.comments = [...this.listComments.getValue(), ...resp.comments];
          this.listComments.next(resp.comments);
          this.unread.next(resp.unreadCount);
        } else {
          this.listComments.next([]);
          this.unread.next(0);
        }
      },
      (err) => {
        this.errorGetCommnents.next(err);
      },
    );
  }

  public saveFile(formData: FormData) {
    const url: string = `${environment.apiBase}/mortgages-docs/${environment.api_version.mortgagesDocs}/documents/uploadDocs`;
    return this.commonService.postVerb(url, formData);
  }

  public saveCommentandFile(
    comment: { text: string; createdBy: string },
    file: FormData,
  ) {
    return this.saveFile(file).pipe(
      switchMap(() => this.setComment(comment)),
      catchError((error) => {
        throw error;
      }),
    );
    // return Observable.forkJoin(
    //   this.setComment(comment),
    //   this.saveFile(file)
    // ).map(res => res[0])
    // .catch(error => {
    //     throw error;
    // });
  }

  public getUnread() {
    return this.unread;
  }

  public getListComments() {
    return this.listComments;
  }

  public getCopleteScroll() {
    return this.completeScroll;
  }

  public getErrorServer() {
    return this.errorGetCommnents;
  }

  setAsRead() {
    // this.unread.next(0);
    const url = `${environment.apiBase}/mortgages-wall/${environment.api_version.wall}/comments`;
    return this.commonService.patchVerb<void>(url, { read: true }).subscribe((resp) => {
      this.markAsRead = false;
      this.unread.next(0);
    });
  }

  // setUnRead(unread: number) {
  //     this.unread.next(unread);
  // }

  public subscribeInterval() {
    this.numSubscriptions++;
    if (this.subscribeInterval) {
      clearInterval(this.commentsInterval);
    }

    this.getComments().subscribe(
      (resp) => {
        this.listComments.next(resp.comments);
        this.unread.next(resp.unreadCount);
        this.errorGetCommnents.next(undefined);
        if (this.markAsRead) {
          this.setAsRead();
        }
      },
      (err) => {
        this.errorGetCommnents.next(err);
      },
    );

    this.commentsInterval = setInterval(() => {
      this.getComments().subscribe(
        (resp) => {
          this.listComments.next(resp.comments);
          this.unread.next(resp.unreadCount);
          this.errorGetCommnents.next(undefined);
          if (this.markAsRead) {
            this.setAsRead();
          }
        },
        (err) => {
          this.errorGetCommnents.next(err);
        },
      );
    }, this.timmerInterval);
  }

  public unsubscribeInterval() {
    this.numSubscriptions--;
    if (this.numSubscriptions === 0) {
      this.listComments.next([]);
      this.unread.next(0);
      clearInterval(this.commentsInterval);
    }
  }
}
